import Vue from "vue";


import Page_343d63fed7308c7437941ed9a631573e from "@/views/100_Intro.vue";

import Page_f66d31bbf9bfceed65bd00b8fca91c05 from "@/views/200_Welcome.vue";

import Page_ccd1113051f0ef8f3371ba9bfc8b41ed from "@/views/300_Whats_in_it_for_You.vue";

import Page_0de02bbb8ec9d64a7eb765b74ca8376c from "@/views/400_Knowledge_Check.vue";

import Page_4729883319f39e0a29e0c67a26eff76a from "@/views/500_KSAT25-30-0300-video-Social_Engineering.vue";

import Page_e47c2bcd9a67502f332df1555ac7fe5d from "@/views/600_KSAT25-30-0400-modal-video-Social_Engineering_Threats.vue";

import Page_e2d4c7b35a21508eb73388b93bdd59e5 from "@/views/700_KSAT25-30-0700-video-Social_Engineering_Red_Flags.vue";

import Page_f498b4e18c3d16429de3ef259dbfe37e from "@/views/800_KSAT25-45-0900-video-Personalized_Attack_Methods.vue";

import Page_17db05e9865f8f1ba57c1e2639a64d34 from "@/views/900_KSAT25-45-1000-modal-video-Stop_Look_and_Think.vue";

import Page_abda1ba10957d190cda5654a715a9a53 from "@/views/1000_Phishing_in_Action.vue";

import Page_ca5229040905c575869d01401461d052 from "@/views/1100_Clicks_Happen.vue";

import Page_3ea78ca51e71aca3db2c5e6a5adb6088 from "@/views/1200_custom-Smishing.vue";

import Page_f76c3120ec4dc8fc4e9bc31a906a5db2 from "@/views/1300_KSAT24-45-Red_Flags_Exercise.vue";

import Page_a5812f6b11d24b5e78bee2daa2e31474 from "@/views/1400_Strong_Password_Infographic.vue";

import Page_fe01ecf56cdff5975a6c2452af40d6b8 from "@/views/1500_Mobile_Devices_and_Remote_Security.vue";

import Page_bf0a46324d10494fb79d8181613e2070 from "@/views/1600_Physical_Security.vue";

import Page_a950d0a9f5a97eb424dd5edd80c27e9a from "@/views/1700_Working_from_Home.vue";

import Page_719d63f6a2914ef710f81846c4cca882 from "@/views/1800_Social_Media_Infographic.vue";

import Page_c776c7c15806a2fb1cf49ac61fbf4f8f from "@/views/1900_Incident_Response.vue";

import Page_90471197d7cfc202af86d1df89009b7b from "@/views/2000_Reporting_Sus_Emails.vue";

import Page_def13a4456d67f8d0ae3c01e053a6844 from "@/views/2100_KSAT25-45-1500-modal-video-AI_Threats.vue";

import Page_733d370f392b56f5dc916b9b4c45839c from "@/views/2200_Key_Takeaways_and_Recap.vue";

import Page_c738cdca3110dd177d1322372cb3d641 from "@/views/2300_Wrap_Up.vue";

import Page_b65db40caaec47a9ccbe30b71c2959e4 from "@/views/2400_Quiz.vue";

import Page_d2a98c2b0da847e1490f526ccbefffee from "@/views/2500_Custom_IR.vue";



import QuizQuestion_c3e3b6805a8c7689d7b6d195311fd636 from "@/views/quiz/question-01.vue";

import QuizQuestion_cc4c2363c0bc7d5db9eb58c0679e354a from "@/views/quiz/question-02.vue";

import QuizQuestion_373ed3ae165d65507cced09937bc6e1d from "@/views/quiz/question-03.vue";

import QuizQuestion_f9bcc461b94530f30ff5ee0eb534d8ec from "@/views/quiz/question-04.vue";

import QuizQuestion_f82c187ebab1f0c02eb4d6e197090912 from "@/views/quiz/question-05.vue";

import QuizQuestion_854c0a05df63beb20aede5f975303fe6 from "@/views/quiz/question-06.vue";

import QuizQuestion_6aa02a2a58132339ffee1ba112594ccd from "@/views/quiz/question-08.vue";

import QuizQuestion_10e8e960640610e64bd8a2b1beabfab9 from "@/views/quiz/question-09.vue";

import QuizQuestion_9878d76fb75773f5a1db3ed637477a0a from "@/views/quiz/question-10.vue";

import QuizQuestion_88ebcbbdea2c81c98c8f00662afb286f from "@/views/quiz/question-11.vue";




import BTB_INTRO from '@/views/BTB_INTRO.vue';
import BTB_OUTRO from '@/views/BTB_OUTRO.vue';
import BTB_INSERT_TEMPLATE from '@/views/BTB_INSERT_TEMPLATE.vue';


Vue.component("Page_343d63fed7308c7437941ed9a631573e", Page_343d63fed7308c7437941ed9a631573e);

Vue.component("Page_f66d31bbf9bfceed65bd00b8fca91c05", Page_f66d31bbf9bfceed65bd00b8fca91c05);

Vue.component("Page_ccd1113051f0ef8f3371ba9bfc8b41ed", Page_ccd1113051f0ef8f3371ba9bfc8b41ed);

Vue.component("Page_0de02bbb8ec9d64a7eb765b74ca8376c", Page_0de02bbb8ec9d64a7eb765b74ca8376c);

Vue.component("Page_4729883319f39e0a29e0c67a26eff76a", Page_4729883319f39e0a29e0c67a26eff76a);

Vue.component("Page_e47c2bcd9a67502f332df1555ac7fe5d", Page_e47c2bcd9a67502f332df1555ac7fe5d);

Vue.component("Page_e2d4c7b35a21508eb73388b93bdd59e5", Page_e2d4c7b35a21508eb73388b93bdd59e5);

Vue.component("Page_f498b4e18c3d16429de3ef259dbfe37e", Page_f498b4e18c3d16429de3ef259dbfe37e);

Vue.component("Page_17db05e9865f8f1ba57c1e2639a64d34", Page_17db05e9865f8f1ba57c1e2639a64d34);

Vue.component("Page_abda1ba10957d190cda5654a715a9a53", Page_abda1ba10957d190cda5654a715a9a53);

Vue.component("Page_ca5229040905c575869d01401461d052", Page_ca5229040905c575869d01401461d052);

Vue.component("Page_3ea78ca51e71aca3db2c5e6a5adb6088", Page_3ea78ca51e71aca3db2c5e6a5adb6088);

Vue.component("Page_f76c3120ec4dc8fc4e9bc31a906a5db2", Page_f76c3120ec4dc8fc4e9bc31a906a5db2);

Vue.component("Page_a5812f6b11d24b5e78bee2daa2e31474", Page_a5812f6b11d24b5e78bee2daa2e31474);

Vue.component("Page_fe01ecf56cdff5975a6c2452af40d6b8", Page_fe01ecf56cdff5975a6c2452af40d6b8);

Vue.component("Page_bf0a46324d10494fb79d8181613e2070", Page_bf0a46324d10494fb79d8181613e2070);

Vue.component("Page_a950d0a9f5a97eb424dd5edd80c27e9a", Page_a950d0a9f5a97eb424dd5edd80c27e9a);

Vue.component("Page_719d63f6a2914ef710f81846c4cca882", Page_719d63f6a2914ef710f81846c4cca882);

Vue.component("Page_c776c7c15806a2fb1cf49ac61fbf4f8f", Page_c776c7c15806a2fb1cf49ac61fbf4f8f);

Vue.component("Page_90471197d7cfc202af86d1df89009b7b", Page_90471197d7cfc202af86d1df89009b7b);

Vue.component("Page_def13a4456d67f8d0ae3c01e053a6844", Page_def13a4456d67f8d0ae3c01e053a6844);

Vue.component("Page_733d370f392b56f5dc916b9b4c45839c", Page_733d370f392b56f5dc916b9b4c45839c);

Vue.component("Page_c738cdca3110dd177d1322372cb3d641", Page_c738cdca3110dd177d1322372cb3d641);

Vue.component("Page_b65db40caaec47a9ccbe30b71c2959e4", Page_b65db40caaec47a9ccbe30b71c2959e4);

Vue.component("Page_d2a98c2b0da847e1490f526ccbefffee", Page_d2a98c2b0da847e1490f526ccbefffee);



Vue.component("QuizQuestion_c3e3b6805a8c7689d7b6d195311fd636", QuizQuestion_c3e3b6805a8c7689d7b6d195311fd636);

Vue.component("QuizQuestion_cc4c2363c0bc7d5db9eb58c0679e354a", QuizQuestion_cc4c2363c0bc7d5db9eb58c0679e354a);

Vue.component("QuizQuestion_373ed3ae165d65507cced09937bc6e1d", QuizQuestion_373ed3ae165d65507cced09937bc6e1d);

Vue.component("QuizQuestion_f9bcc461b94530f30ff5ee0eb534d8ec", QuizQuestion_f9bcc461b94530f30ff5ee0eb534d8ec);

Vue.component("QuizQuestion_f82c187ebab1f0c02eb4d6e197090912", QuizQuestion_f82c187ebab1f0c02eb4d6e197090912);

Vue.component("QuizQuestion_854c0a05df63beb20aede5f975303fe6", QuizQuestion_854c0a05df63beb20aede5f975303fe6);

Vue.component("QuizQuestion_6aa02a2a58132339ffee1ba112594ccd", QuizQuestion_6aa02a2a58132339ffee1ba112594ccd);

Vue.component("QuizQuestion_10e8e960640610e64bd8a2b1beabfab9", QuizQuestion_10e8e960640610e64bd8a2b1beabfab9);

Vue.component("QuizQuestion_9878d76fb75773f5a1db3ed637477a0a", QuizQuestion_9878d76fb75773f5a1db3ed637477a0a);

Vue.component("QuizQuestion_88ebcbbdea2c81c98c8f00662afb286f", QuizQuestion_88ebcbbdea2c81c98c8f00662afb286f);




Vue.component('BTB_INTRO', BTB_INTRO);
Vue.component('BTB_OUTRO', BTB_OUTRO);
Vue.component('BTB_INSERT_TEMPLATE', BTB_INSERT_TEMPLATE);
